import { Typography } from '@material-ui/core'
import { Skeleton } from '@material-ui/lab'

import useStyles from './styles/FacilitiesCategory.styles'

const FacilitiesCategorySkeleton = () => {
  const classes = useStyles()
  return (
    <div className={classes.root}>
      <Typography variant="h3" className={classes.title}>
        {/* {data.icon} */}
        <Skeleton animation="wave" className={classes.titleSkeleton} />
      </Typography>
      <div className={classes.itemsContainer}>
        {[...Array(14)].map((_, index) => (
          <div className={classes.formControlItemSkeleton}>
            <Skeleton
              key={index.toString()}
              animation="wave"
              className={classes.checkboxLabelSkeleton}
            />
          </div>
        ))}
      </div>
    </div>
  )
}

export default FacilitiesCategorySkeleton
